import React, { useState, useEffect, useRef } from 'react';
import PageContainer from '../../components/container/PageContainer';
import {
  Box,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import Step1 from '../../assets/images/step1.png';
import Step2 from '../../assets/images/step2.png';
import Step3 from '../../assets/images/step3.png';
import Step4 from '../../assets/images/step4.png';
import PowerCard from '../../assets/images/PowerCard.png';
import PrideCard from '../../assets/images/PrideCard.png';
import ConfidenceCard from '../../assets/images/ConfidenceCard.png';
import CourageCard from '../../assets/images/CourageCard.png';
import Emblem from '../../assets/images/emblem.png';
import Footer from '../../layouts/full-layout/footer/Footer';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { Field, Form, Formik } from 'formik';
import CustomTextField from '../../components/forms/custom-elements/CustomTextField';
import CustomSelect from '../../components/forms/custom-elements/CustomSelect';
import CustomFormLabel from '../../components/forms/custom-elements/CustomFormLabel';
import CustomCheckBox from '../../components/forms/custom-elements/CustomCheckbox';
import * as Yup from 'yup';
import { values } from 'lodash';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import Certificate from '../../components/certificate';

const steps = [
  {
    imageLink: Step1,
    altTag: 'Step 1',
  },
  {
    imageLink: Step2,
    altTag: 'Step 2',
  },
  {
    imageLink: Step3,
    altTag: 'Step 3',
  },
  {
    imageLink: Step4,
    altTag: 'Step 4',
  },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 100,
  slidesToShow: 1, // Show one image at a time
  slidesToScroll: 1,
  autoplay: true, // Enable auto scrolling
  autoplaySpeed: 3000, // Duration for which each slide is displayed (in milliseconds)
};

const Activities = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [openModal, setOpenModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activityType, setActivityType] = useState('POWER');
  const [openCertificateModal, setCertificateModal] = useState(false)
  const [username, setUserName] = useState("")

  const formikRef = useRef(null);

  const { enqueueSnackbar } = useSnackbar();

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const initialValues = {
    name: '',
    pledge: '',
    media_url_1: null,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    pledge: Yup.boolean()
      .required('Field is required')
      .when('activityType', {
        is: 'POWER', // Check if activityType is 'POWER'
        then: () => Yup.boolean().required('Field is required'), // Ensure pledge is required when activityType is 'POWER'
        otherwise: () => Yup.boolean(), // Otherwise, still treat it as a boolean but no need for the required condition
      }),
  });

  const handleFileUpload = (e) => {
    console.log(e);
  };

  const handleSubmit = async (values, resetForm) => {
    if (activityType === 'POWER') {
      enqueueSnackbar('Media Uploaded', { variant: 'success' });
      setOpenModal(false)
      setUserName(values.name)
      setCertificateModal(true)
    } else {
      enqueueSnackbar('Media Uploaded', { variant: 'success' });
      window.location.reload()
    }
  };

  return (
    <PageContainer title="Activities" description="This is Activities Page">
      {!isMobile ? (
        <>
          <Box sx={{ marginTop: '90px', padding: '2% 10%' }}>
            <Grid container spacing={3}>
              {steps.map((step) => (
                <Grid item xs={12} md={3}>
                  <img src={step.imageLink} alt={step.altTag} style={{ width: '100%' }} />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box sx={{ padding: '0 5%' }}>
            <Card>
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    textAlign: 'center',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      gap: '20px',
                    }}
                  >
                    <Box
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        setActivityType('POWER');
                        setOpenModal(true);
                      }}
                    >
                      <img src={PowerCard} alt="PowerCard" style={{ width: '60%' }} />
                    </Box>
                    <Box
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        setActivityType('PRIDE');
                        setOpenModal(true);
                      }}
                    >
                      <img src={PrideCard} alt="PrideCard" style={{ width: '60%' }} />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <img src={Emblem} alt="Emblem" style={{ width: '60%' }} />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      gap: '20px',
                    }}
                  >
                    <Box
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        setActivityType('CONFIDENCE');
                        setOpenModal(true);
                      }}
                    >
                      <img src={ConfidenceCard} alt="ConfidenceCard" style={{ width: '60%' }} />
                    </Box>
                    <Box
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        setActivityType('COURAGE');
                        setOpenModal(true);
                      }}
                    >
                      <img src={CourageCard} alt="CourageCard" style={{ width: '60%' }} />
                    </Box>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </>
      ) : (
        <Box sx={{ marginTop: '90px', padding: '2% 10%' }}>
          <Box textAlign="center">
            <Box>
              <img src={Emblem} alt="Emblem" style={{ width: '60%' }} />
            </Box>
          </Box>
          <Box mt={3}>
            <Slider {...settings}>
              {steps.map((step, index) => (
                <Box key={index} sx={{ textAlign: 'center' }}>
                  <img src={step.imageLink} alt={step.altTag} style={{ width: '100%' }} />
                </Box>
              ))}
            </Slider>
          </Box>
          <Box mt={5} textAlign="center">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <Box
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setActivityType('POWER');
                  setOpenModal(true);
                }}
              >
                <img src={PowerCard} alt="PowerCard" style={{ width: '60%' }} />
              </Box>
              <Box
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setActivityType('PRIDE');
                  setOpenModal(true);
                }}
              >
                <img src={PrideCard} alt="PrideCard" style={{ width: '60%' }} />
              </Box>
              <Box
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setActivityType('CONFIDENCE');
                  setOpenModal(true);
                }}
              >
                <img src={ConfidenceCard} alt="ConfidenceCard" style={{ width: '60%' }} />
              </Box>
              <Box
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setActivityType('COURAGE');
                  setOpenModal(true);
                }}
              >
                <img src={CourageCard} alt="CourageCard" style={{ width: '60%' }} />
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <Footer />
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>
          {activityType === 'POWER' && (
            <Typography variant="subtitle1">
              <b>POWER</b> - Take a pledge to become a responsible citizen of India and make it a
              better place to live in for the coming generations
            </Typography>
          )}
          {activityType === 'PRIDE' && (
            <Typography variant="subtitle1">
              <b>PRIDE</b> - Folk dances are an important aspect of our country's culture. In
              distant places, these forms and expressions of Indian art earn India love, fame, and
              respect.
            </Typography>
          )}
          {activityType === 'COURAGE' && (
            <Typography variant="subtitle1">
              <b>COURAGE</b> - This is an attempt to recognise and recollect the real heroes of our
              freedom struggle, many of whom may be well-known yet unknown to the younger
              generation.
            </Typography>
          )}
          {activityType === 'CONFIDENCE' && (
            <Typography variant="subtitle1">
              <b>CONFIDENCE</b> - This is an attempt to feel proud of what differentiates us as Indian
              citizens.
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              touched,
              values,
              handleChange,
              setFieldValue,
              isSubmitting,
              resetForm,
            }) => (
              <Form>
                <Grid container spacing={3} mb={4}>
                  {/* Name */}
                  <Grid item xs={12}>
                    <CustomFormLabel>Name*</CustomFormLabel>
                    <Field
                      as={CustomTextField}
                      name="name"
                      autoComplete="off"
                      type="text"
                      fullWidth
                      error={touched.name && errors.name && <div>{errors.name}</div>}
                      helperText={touched.name && errors.name}
                    />
                  </Grid>
                  {activityType === 'POWER' && (
                    <>
                      <Grid item xs={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                          <Field
                            as={CustomCheckBox}
                            name="pledge"
                            fullWidth
                            onChange={(event) => {
                              const isChecked = event.target.checked;
                              setFieldValue('pledge', isChecked); // Update the value to boolean true/false
                            }}
                          />
                          <CustomFormLabel>
                            I pledge to fulfill my responsibility as a citizen to contribute towards
                            building a better India.*
                          </CustomFormLabel>
                        </Box>
                        {errors.pledge && <div style={{ color: 'red' }}>{errors.pledge}</div>}
                      </Grid>
                    </>
                  )}
                  {(activityType === 'POWER' || activityType === 'COURAGE') && (
                    <Grid item xs={12}>
                      {activityType === 'POWER' ? (
                        <CustomFormLabel>Upload Selfie*</CustomFormLabel>
                      ) : (
                        <CustomFormLabel>Upload Photo*</CustomFormLabel>
                      )}
                      <input
                        type="file"
                        name="media_url_1"
                        onChange={(e) => handleFileUpload(e, 'media_url_1', setFieldValue)}
                        accept="image/*"
                      />
                      {errors.media_url_1 && touched.media_url_1 && (
                        <div style={{ color: 'red' }}>{errors.media_url_1}</div>
                      )}
                    </Grid>
                  )}

                  {(activityType === 'PRIDE' || activityType === 'CONFIDENCE') && (
                    <Grid item xs={12}>
                      <CustomFormLabel>Upload Video*</CustomFormLabel>
                      <input
                        type="file"
                        name="media_url_1"
                        onChange={(e) => handleFileUpload(e, 'media_url_1', setFieldValue)}
                        accept="video/mp4, video/webm, video/ogg"
                      />
                      {errors.media_url_1 && touched.media_url_1 && (
                        <div style={{ color: 'red' }}>{errors.media_url_1}</div>
                      )}
                    </Grid>
                  )}
                </Grid>

                <Grid container justifyContent="center" sx={{ mt: 4 }}>
                  <Grid item>
                    <LoadingButton
                      loading={isSubmitting}
                      color="primary"
                      variant="contained"
                      type="submit"
                      size="large"
                    >
                      Submit
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openCertificateModal}
        onClose={() => setCertificateModal(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Box textAlign="center">
            <Certificate username={username} />
          </Box>
        </DialogContent>
      </Dialog>
    </PageContainer>
  );
};

export default Activities;
